import { EditMenu } from "../pages/AdminMenu/AdminMenu";
import { useNavigate } from "react-router-dom";
import {
  DeleteSavedButton,
  DeleteScheduleButton,
  DollarConvert,
  LoanAccCustomCell,
  LoanAccCustomNewTabCell,
  NavigateButton,
  StatusChip,
  daysToMonthsAndDaysV2,
  IncidentIdCustomCell,
  DateConvert,
  calculateDaysOld,
  Dot,
  AttachmentCell,
  LoanAccCustomCellNewTab,
  LoanAccCustomCellForSubrows,
  PercentageConvert,
  BlurWrapper,
  BlurWrapperWithSpan,
  LoanAccCustomCellForPropertyInfo,
  DeleteButton,
  LoanAccCustomCellParentRecID,
  PayOffCustomCell,
  NavigateButtonForScheduleReport,
  HandleFrequency,
  LoadingButton,
  DownloadButtonForReports,
  PayOffRequestCell,
  PayOffRequestCellV2,
} from "./CustomComponent";
import { Badge, Button, OverlayTrigger, Popover, Spinner, Tooltip } from "react-bootstrap";
import { backgroundColors } from "../components/PieChartWithTable";
import { useDispatch, useSelector } from "react-redux";
import { setPieSelected } from "../store/reducers/dashboardSlice";
import RtfViewer, { extractTextFromRTF } from "../components/RtfViewer";
import useDeleteBankAccount from "../hooks/useDeleteBankAccount";
import { LoanAccCustomCellForBorrowers } from "./CustomComponent";
import {
  ArrowRepeat,
  CheckCircleFill,
  ClockHistory,
  HourglassSplit,
  PauseFill,
  Pencil,
  PencilSquare,
  PlayFill,
  Trash,
  XCircleFill,
  CloudDownload
} from "react-bootstrap-icons";
import moment from "moment";
import DownloadIcon from "mdi-react/DownloadIcon";
import urls from "./urls";
import axios from "axios";
import { oracleConfig } from "./constant";
import { useState } from "react";
import { toast } from "react-toastify";
import { commonToast } from ".";

export const InsuranceMonitoringBadge = (props) => {
  const user = useSelector((state) => state.RS_Authentication.user);
  const navigate = useNavigate();

  const isBroadviewAccount = user.details.email?.includes("broadview");
  const value = props?.props?.value;
  const row = props?.props?.row?.original;

  const badges = {
    Pending: { count: 0, bg: "yellow", color: "black", text: "Pending" },
    "Forced Placed": {
      count: 0,
      bg: "blue",
      color: "white",
      text: "Forced Placed",
    },
    Insured: { count: 0, bg: "green", color: "white", text: "Insured" },
    Expired: { count: 0, bg: "red", color: "white", text: "Expired" },
  };

  const newBadges = {
    "Expiring in 30 days": {
      count: 0,
      bg: "yellow",
      color: "black",
      text: "Expiring in 30 days",
    },
    "Forced Placed Expires in 30 days": {
      count: 0,
      bg: "red",
      color: "white",
      text: "Forced Placed Expires in 30 days",
    },
    Current: { count: 0, bg: "green", color: "white", text: "Current" },
    "Forced Placed Current": {
      count: 0,
      bg: "#f57c00",
      color: "white",
      text: "Forced Placed Current",
    },
    "No Proof / Lapse of Insurance": {
      count: 0,
      bg: "red",
      color: "white",
      text: "No Proof / Lapse of Insurance",
    },
    Pending: {
      count: 0,
      bg: "white",
      color: "black",
      text: "Pending",
      border: "1px solid black",
    },
  };

  // Update counts based on value array
  value?.forEach((data) => {
    if (data?.includes("yellow")) newBadges["Expiring in 30 days"].count += 1;
    else if (data?.includes("blue-green"))
      newBadges["Forced Placed Current"].count += 1;
    else if (data?.includes("green")) newBadges.Current.count += 1;
    else if (data?.includes("blue-yellow"))
      newBadges["Forced Placed Expires in 30 days"].count += 1;
    else if (data?.includes("red"))
      newBadges["No Proof / Lapse of Insurance"].count += 1;
    else if (data?.includes("Pending")) newBadges.Pending.count += 1;
  });
  // if (isBroadviewAccount) {
  //   value?.forEach((data) => {
  //     if (data?.includes("yellow")) newBadges["Expiring in 30 days"].count += 1;
  //     else if (data?.includes("blue-green"))
  //       newBadges["Forced Placed Current"].count += 1;
  //     else if (data?.includes("green")) newBadges.Current.count += 1;
  //     else if (data?.includes("blue-yellow"))
  //       newBadges["Forced Placed Expires in 30 days"].count += 1;
  //     else if (data?.includes("red"))
  //       newBadges["No Proof / Lapse of Insurance"].count += 1;
  //     else if (data?.includes("Pending")) newBadges.Pending.count += 1;
  //   });
  // } else {
  //   value?.forEach((data) => {
  //     if (data?.includes("Pending") || data?.includes("yellow"))
  //       badges.Pending.count += 1;
  //     else if (data?.includes("blue-green")) badges["Forced Placed"].count += 1;
  //     else if (data?.includes("green")) badges.Insured.count += 1;
  //     else badges.Expired.count += 1;
  //   });
  // }

  // Function to generate badge components
  const generateBadges = () =>
    // Object.entries(isBroadviewAccount ? newBadges : badges)
    Object.entries(newBadges)
      .map(([key, { count, bg, color, text, border }]) =>
        count ? (
          <Badge
            onClick={
              !props?.borrower
                ? () => {
                    if (!props?.disableOnClick) {
                      navigate(
                        "/loan-details/" +
                          (row?.loan_id ? row?.loan_id : row?.loan_recid) +
                          "/1",
                      );
                    }
                  }
                : () => {
                    if (!props?.disableOnClick) {
                      navigate(
                        "/loan-details-borrower/" +
                          (row?.loan_id ? row?.loan_id : row?.loan_recid) +
                          "/1",
                      );
                    }
                  }
            }
            role="button"
            key={key}
            bg={bg}
            style={{
              color,
              background: bg,
              border: border,
              textWrap: "pretty",
            }}
            className="d-inline-block text-wrap-auto align-items-center"
          >
            {count} {text}
          </Badge>
        ) : null,
      )
      .filter(Boolean); // Filter out null values to avoid rendering empty elements

  const badgesCount = generateBadges()?.length;

  return (
    <span
      className={`me-2 ${badgesCount > 1 ? "d-flex flex-column" : ""}`}
      style={badgesCount > 1 ? { overflow: "scroll", maxHeight: "6vh" } : null}
    >
      {generateBadges()}
    </span>
  );
};
export const gridColumns_LoanAgeing = [
  {
    title: "Loan",
    field: "loan_account",
    // Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
    Cell: (props) => <LoanAccCustomCellParentRecID props={props} />,
  },
  {
    title: "Primary Borrower",
    field: "primaryBorrower",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    title: "Primary Borrower Address",
    field: "Address",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    title: "Principal Balance",
    field: "principalBalance",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    title: "Current",
    field: "current",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    title: "0-30",
    field: "zeroToThirty",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    title: "31-60",
    field: "tillSixty",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    title: "61-90",
    field: "tillNinety",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    title: "91+",
    field: "NinetyOnePlus",
    Cell: (props) => <DollarConvert props={props} />,
  },
];
export const gridColumns_PortfolioAtGlance = [
  {
    field: "account",
    title: "Loan Acc",
    style: { width: "15%", wordBreak: "break-all" },
    Cell: (props) => <LoanAccCustomCell props={props} />,
  },
  {
    field: "loan_info",
    title: "Loan Info",
    style: { width: "20%", wordBreak: "break-all" },
    Cell: ({ value }) => (
      <BlurWrapper>
        <span>{value}</span>
      </BlurWrapper>
    ),
  },
  {
    field: "next_due_date",
    title: "Next due date",
    style: { width: "10%", wordBreak: "break-all" },
  },
  // {
  //   field: "ytd_interest",
  //   title: "YTD Interest",
  //   style: { width: "10%", wordBreak: "break-all" },
  // },
  {
    field: "maturity_date",
    title: "Maturity Date",
    style: { width: "10%", wordBreak: "break-all" },
  },
  // {
  //   field: "maturity_date",
  //   title: "Time to Maturity",
  //   style: { width: "10%", wordBreak: "break-all" },
  // },
  {
    field: "days_to_maturity",
    title: "Time to Maturity",
    style: { width: "13%", wordBreak: "break-all" },
    Cell: ({ value }) => (
      <span style={{ color: value < 0 ? "red" : "" }}>
        {value < 0
          ? `${daysToMonthsAndDaysV2(value)}`
          : daysToMonthsAndDaysV2(value)}
      </span>
    ),
  },
  {
    title: "Insurance Monitoring",
    field: "insurance_info",
    // Cell: (props) => <img src={props?.value} width="40" alt="" />,
    Cell: (props) => <InsuranceMonitoringBadge props={props} />,
    // Cell: (props) => <span>{props?.value.contains("Pending")?"pending":"green"}</span>,
    // Cell: (props) => {

    //   // if(typeof(props.value)=='string')
    //   // return <span>{props?.value.contains("Pending")?"pending":"green"}</span>
    //   return <span>not given</span>;
    // },
    style: { width: "15%", wordBreak: "break-all" },
  },

  // {
  //   field: "principal",
  //   title: "Principal Ion",
  //   style: { width: "10%" },
  //   Cell: (props) => <DollarConvert props={props} />,
  // },
  {
    field: "principal",
    title: "Lender Principal Investment",
    style: { width: "15%" },
    Cell: (props) => <DollarConvert props={props} />,
  },
];

export const gridColumns_PortfolioAtGlanceNew = [
  {
    field: "account",
    title: "Loan Acc",
    style: { width: "15%", wordBreak: "break-all" },
    Cell: (props) => <LoanAccCustomCell props={props} />,
  },
  {
    field: "loan_info",
    title: "Loan Info",
    style: { width: "20%", wordBreak: "break-all" },
    Cell: ({ value }) => (
      <BlurWrapper>
        <span>{value}</span>
      </BlurWrapper>
    ),
  },
  {
    field: "Property Address",
    title: "Property Address",
    style: { width: "20%", wordBreak: "break-all" },
    Cell: ({ value }) => (
      <BlurWrapper>
        <span>{value}</span>
      </BlurWrapper>
    ),
  },
  {
    field: "next_due_date",
    title: "Next due date",
    style: { width: "10%", wordBreak: "break-all" },
  },
  // {
  //   field: "ytd_interest",
  //   title: "YTD Interest",
  //   style: { width: "10%", wordBreak: "break-all" },
  // },
  {
    field: "maturity_date",
    title: "Maturity Date",
    style: { width: "10%", wordBreak: "break-all" },
  },
  // {
  //   field: "maturity_date",
  //   title: "Time to Maturity",
  //   style: { width: "10%", wordBreak: "break-all" },
  // },
  {
    field: "maturity_date_In_days",
    title: "Time to Maturity",
    style: { width: "13%", wordBreak: "break-all" },
    // Cell: ({ value }) => (
    //   <span style={{ color: value < 0 ? "red" : "" }}>
    //     {value < 0
    //       ? `${daysToMonthsAndDaysV2(value)}`
    //       : daysToMonthsAndDaysV2(value)}
    //   </span>
    // ),
  },
  {
    title: "Insurance Monitoring",
    field: "insurance_info",
    // Cell: (props) => <img src={props?.value} width="40" alt="" />,
    Cell: (props) => <InsuranceMonitoringBadge props={props} />,
    // Cell: (props) => <span>{props?.value.contains("Pending")?"pending":"green"}</span>,
    // Cell: (props) => {

    //   // if(typeof(props.value)=='string')
    //   // return <span>{props?.value.contains("Pending")?"pending":"green"}</span>
    //   return <span>not given</span>;
    // },
    style: { width: "15%", wordBreak: "break-all" },
    shouldWrap: true,
  },

  // {
  //   field: "principal",
  //   title: "Principal Ion",
  //   style: { width: "10%" },
  //   Cell: (props) => <DollarConvert props={props} />,
  // },
  {
    field: "principal",
    title: "Lender Principal Investment",
    style: { width: "15%" },
    Cell: (props) => <DollarConvert props={props} />,
  },
];

export const gridColumns_PortfolioAtGlanceBroker = [
  {
    field: "account",
    title: "Loan Acc",
    style: { width: "15%", wordBreak: "break-all" },
    Cell: (props) => <LoanAccCustomCell props={props} />,
  },
  {
    field: "loan_info",
    title: "Loan Info",
    style: { width: "20%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "Property Address",
    title: "Property Address",
    style: { width: "20%", wordBreak: "break-all" },
    Cell: ({ value }) => (
      <BlurWrapper>
        <span>{value}</span>
      </BlurWrapper>
    ),
  },
  {
    field: "next_due_date",
    title: "Next due date",
    style: { width: "10%", wordBreak: "break-all" },
  },
  // {
  //   field: "ytd_interest",
  //   title: "YTD Interest",
  //   style: { width: "10%", wordBreak: "break-all" },
  // },
  {
    field: "maturity_date",
    title: "Maturity Date",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "days_to_maturity",
    title: "Time to Maturity",
    style: { width: "13%", wordBreak: "break-all" },
    Cell: ({ value }) => (
      <span style={{ color: value < 0 ? "red" : "" }}>
        {value < 0
          ? `${daysToMonthsAndDaysV2(value)}`
          : daysToMonthsAndDaysV2(value)}
      </span>
    ),
  },
  {
    title: "Insurance Monitoring",
    field: "insurance_info",
    Cell: (props) => <InsuranceMonitoringBadge props={props} />,
    style: { width: "15%", wordBreak: "break-all" },
    shouldWrap: true,
  },

  {
    field: "principal",
    title: "Loan Principal Balance",
    style: { width: "15%" },
    Cell: (props) => <DollarConvert props={props} />,
  },
];
export const gridColumns_PortfolioAtGlanceNewTab = [
  {
    field: "account",
    title: "Loan Acc",
    style: { width: "15%", wordBreak: "break-all" },
    Cell: (props) => <LoanAccCustomCellNewTab props={props} />,
  },
  {
    field: "loan_info",
    title: "Loan Info",
    style: { width: "20%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "next_due_date",
    title: "Next due date",
    style: { width: "10%", wordBreak: "break-all" },
  },
  // {
  //   field: "ytd_interest",
  //   title: "YTD Interest",
  //   style: { width: "10%", wordBreak: "break-all" },
  // },
  {
    field: "maturity_date",
    title: "Maturity Date",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  // {
  //   field: "maturity_date",
  //   title: "Time to Maturity",
  //   style: { width: "10%", wordBreak: "break-all" },
  // },
  {
    field: "days_to_maturity",
    title: "Time to Maturity",
    style: { width: "13%", wordBreak: "break-all" },
    Cell: ({ value }) => (
      <span style={{ color: value < 0 ? "red" : "" }}>
        {value < 0
          ? `${daysToMonthsAndDaysV2(value)}`
          : daysToMonthsAndDaysV2(value)}
      </span>
    ),
  },
  {
    title: "Insurance Monitoring",
    field: "insurance_info",
    // Cell: (props) => <img src={props?.value} width="40" alt="" />,
    Cell: (props) => <InsuranceMonitoringBadge props={props} />,
    // Cell: (props) => <span>{props?.value.contains("Pending")?"pending":"green"}</span>,
    // Cell: (props) => {

    //   // if(typeof(props.value)=='string')
    //   // return <span>{props?.value.contains("Pending")?"pending":"green"}</span>
    //   return <span>not given</span>;
    // },
    style: { width: "15%", wordBreak: "break-all" },
  },

  // {
  //   field: "principal",
  //   title: "Principal Ion",
  //   style: { width: "10%" },
  //   Cell: (props) => <DollarConvert props={props} />,
  // },
  {
    field: "principal",
    title: "Lender Principal Investment",
    style: { width: "15%" },
    Cell: (props) => <DollarConvert props={props} />,
  },
];
export const gridColumns_PortfolioAtGlanceNewTabBroker = [
  {
    field: "account",
    title: "Loan Acc",
    style: { width: "15%", wordBreak: "break-all" },
    Cell: (props) => <LoanAccCustomCellNewTab props={props} />,
  },
  {
    field: "loan_info",
    title: "Loan Info",
    style: { width: "20%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "next_due_date",
    title: "Next due date",
    style: { width: "10%", wordBreak: "break-all" },
  },
  // {
  //   field: "ytd_interest",
  //   title: "YTD Interest",
  //   style: { width: "10%", wordBreak: "break-all" },
  // },
  {
    field: "maturity_date",
    title: "Maturity Date",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "days_to_maturity",
    title: "Time to Maturity",
    style: { width: "13%", wordBreak: "break-all" },
    Cell: ({ value }) => (
      <span style={{ color: value < 0 ? "red" : "" }}>
        {value < 0
          ? `${daysToMonthsAndDaysV2(value)}`
          : daysToMonthsAndDaysV2(value)}
      </span>
    ),
  },
  {
    title: "Insurance Monitoring",
    field: "insurance_info",
    Cell: (props) => <InsuranceMonitoringBadge props={props} />,
    style: { width: "15%", wordBreak: "break-all" },
  },
  {
    field: "principal",
    title: "Original Loan Balance",
    style: { width: "15%" },
    Cell: (props) => <DollarConvert props={props} />,
  },
];
export const gridColumns_PastPortfolio = [
  {
    field: "account",
    title: "Loan Acc",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: (props) => <LoanAccCustomCell props={props} />,
  },
  {
    field: "loan_info",
    title: "Loan Info",
    style: { width: "20%", wordBreak: "break-all" },
    Cell: ({ value }) => (
      <BlurWrapper>
        <span>{value}</span>
      </BlurWrapper>
    ),
  },
  {
    field: "Property Address",
    title: "Property Address",
    style: { width: "20%", wordBreak: "break-all" },
    Cell: ({ value }) => (
      <BlurWrapper>
        <span>{value}</span>
      </BlurWrapper>
    ),
  },
  // {
  //   field: "next_due_date",
  //   title: "Next due date",
  //   style: { width: "10%", wordBreak: "break-all" },
  // },
  {
    field: "ytd_interest",
    title: "YTD Interest",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: (props) => <DollarConvert props={props} />,
  },
  // {
  //   field: "maturity_date",
  //   title: "Time to Maturity",
  //   style: { width: "10%", wordBreak: "break-all" },
  // },
  {
    // field: "maturity_date",
    field: "payoff_date",
    title: "Payoff Date",
    style: { width: "10%", wordBreak: "break-all" },
  },
  // {
  //   field: "days_to_maturity",
  //   title: "Time to Maturity",
  //   style: { width: "10%", wordBreak: "break-all" },
  //   Cell: ({ value }) => (
  //     <span style={{ color: value < 0 ? "red" : "" }}>
  //       {value < 0
  //         ? `${daysToMonthsAndDaysV2(value)}`
  //         : daysToMonthsAndDaysV2(value)}
  //     </span>
  //   ),
  // },
  // {
  //   title: "Insurance Monitoring",
  //   field: "insurance_info",
  //   Cell: (props) => <img src={props?.value} width="40" alt="" />,
  //   // Cell: (props) => <span>{props?.value?.contains('Pending')?'pending':props?.value?.contains('green')?'green':'yellow'}</span>,
  //   style: { width: "10%", wordBreak: "break-all" },
  // },

  // {
  //   field: "principal",
  //   title: "Principal Ion",
  //   style: { width: "10%" },
  //   Cell: (props) => <DollarConvert props={props} />,
  // },
  {
    field: "principal",
    title: "Lender Principal Investment",
    style: { width: "10%" },
    Cell: (props) => <DollarConvert props={props} />,
  },
];
export const gridColumns_PastPortfolioBroker = [
  {
    field: "account",
    title: "Loan Acc",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: (props) => <LoanAccCustomCell props={props} />,
  },
  {
    field: "loan_info",
    title: "Loan Info",
    style: { width: "20%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "Property Address",
    title: "Property Address",
    style: { width: "20%", wordBreak: "break-all" },
    Cell: ({ value }) => (
      <BlurWrapper>
        <span>{value}</span>
      </BlurWrapper>
    ),
  },
  // {
  //   field: "next_due_date",
  //   title: "Next due date",
  //   style: { width: "10%", wordBreak: "break-all" },
  // },
  // {
  //   field: "maturity_date",
  //   title: "Time to Maturity",
  //   style: { width: "10%", wordBreak: "break-all" },
  // },
  {
    // field: "maturity_date",
    field: "payoff_date",
    title: "Payoff Date",
    style: { width: "10%", wordBreak: "break-all" },
  },
  // {
  //   field: "days_to_maturity",
  //   title: "Time to Maturity",
  //   style: { width: "10%", wordBreak: "break-all" },
  //   Cell: ({ value }) => (
  //     <span style={{ color: value < 0 ? "red" : "" }}>
  //       {value < 0
  //         ? `${daysToMonthsAndDaysV2(value)}`
  //         : daysToMonthsAndDaysV2(value)}
  //     </span>
  //   ),
  // },
  // {
  //   title: "Insurance Monitoring",
  //   field: "insurance_info",
  //   Cell: (props) => <img src={props?.value} width="40" alt="" />,
  //   // Cell: (props) => <span>{props?.value?.contains('Pending')?'pending':props?.value?.contains('green')?'green':'yellow'}</span>,
  //   style: { width: "10%", wordBreak: "break-all" },
  // },

  // {
  //   field: "principal",
  //   title: "Principal Ion",
  //   style: { width: "10%" },
  //   Cell: (props) => <DollarConvert props={props} />,
  // },
  {
    field: "principal",
    title: "Original Loan Balance",
    style: { width: "10%" },
    Cell: (props) => <DollarConvert props={props} />,
  },
];
export const gridColumns_EventsJournal = [
  {
    field: "account",
    title: "Loan Acc",
    style: { width: "10%" },
  },
  {
    field: "event",
    title: "Event Info",
    style: { width: "30%" },
  },
  {
    field: "entered_by",
    title: "Entered By",
    style: { width: "10%" },
  },
  {
    field: "event_date",
    title: "Event Date",
    style: { width: "10%" },
  },
];
export const gridColumns_UpcomingPayments = [
  {
    // field: "Loan Account",
    field: "account",
    title: "Account",
    Cell: (props) => <LoanAccCustomCellForSubrows props={props} />,
  },
  {
    field: "Property Address",
    // field: "address",
    title: "Address",
    Cell: ({ value }) => (
      <BlurWrapper>
        <span>{value}</span>
      </BlurWrapper>
    ),
  },
  {
    field: "Check Date",
    // field: "check_date",
    title: "Release Date",
  },
  {
    field: "Check Number",
    // field: "check_number",
    title: "Payment Status",
  },
  {
    field: "Amount",
    // field: "amount",
    title: "Amount",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "viewMore",
    title: "View More",
    Header: ({ getToggleAllRowsExpandedProps }) => (
      <span {...getToggleAllRowsExpandedProps()}>View All</span>
    ),
    Cell: ({ row }) =>
      row.original.subRows ? (
        <button className="btn-primary" {...row?.getToggleRowExpandedProps({})}>
          View More
        </button>
      ) : null,
  },
];
export const gridColumns_PastPayments = [
  {
    field: "account",
    title: "Trans | A/C",
    Cell: (props) => <LoanAccCustomCellForSubrows props={props} />,
  },
  {
    field: "check_date",
    title: "Check Date",
  },
  {
    field: "check_no",
    title: "Check No",
    Cell: ({ value }) => (
      <BlurWrapper>
        <span>{value}</span>
      </BlurWrapper>
    ),
  },
  // {
  //   field: "payment_code",
  //   title: "Payment Code",
  //   Cell: ({ value }) => (
  //     <BlurWrapper>
  //       <span>{value}</span>
  //     </BlurWrapper>
  //   ),
  // },
  {
    field: "date_due",
    title: "Date Due",
  },
  // {
  //   field: "date_received",
  //   title: "Date Received",
  // },
  {
    field: "amount",
    title: "Amount",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "principal",
    title: "Principal",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "interest",
    title: "Interest",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "servicingFee",
    title: "Servicing Fee",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "lateCharge",
    title: "Late Charge",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "other",
    title: "Other",
    Cell: (props) => <DollarConvert props={props} />,
  },
  // {
  //   field: "loanBalance",
  //   title: "Loan Balance",
  //   Cell: (props) => <DollarConvert props={props} />,
  // },
  {
    field: "viewMore",
    title: "View More",
    Header: ({ getToggleAllRowsExpandedProps }) => (
      <span {...getToggleAllRowsExpandedProps()}>View All</span>
    ),
    Cell: ({ row }) =>
      row.original.subRows ? (
        <button className="btn-primary" {...row?.getToggleRowExpandedProps({})}>
          View More
        </button>
      ) : null,
  },
];
export const gridColumns_PastPayments_Broker = [
  {
    field: "Account",
    title: "Account",
    // Cell: (props) => <LoanAccCustomCell props={props} />,
    Cell: (props) => (
      <span>
        {props && props.value ? props.value.split(">")[1].split("<")[0] : ""}
      </span>
    ),
  },
  {
    field: "Check Date",
    title: "Check Date",
  },
  {
    field: "Check Number",
    title: "Check No",
  },
  {
    field: "Principal",
    title: "Principal",
  },
  {
    field: "Interest",
    title: "Interest",
  },
  {
    field: "Servicing Fee",
    title: "Servicing Fee",
  },
  {
    field: "Late Charge",
    title: "Late Charge",
  },
  {
    field: "Other",
    title: "Other",
  },
  {
    field: "Loan Balance",
    title: "Loan Balance",
  },
  {
    field: "Amount",
    title: "Amount",
    Cell: (props) => <DollarConvert props={props} />,
  },
];
export const gridColumns_pastLoanPortfolio = [
  {
    field: "loan_acc",
    title: "loan_acc",
  },
  {
    field: "loan_info",
    title: "loan_info",
  },
  {
    field: "1st_payment",
    title: "1st_payment",
  },
  {
    field: "payoff_date",
    title: "payoff_date",
  },
  {
    field: "original_loan",
    title: "original_loan",
  },
];
export const gridColumns_loanSubmissions = [
  {
    field: "loan_no",
    title: "Loan No",
  },
  {
    field: "address",
    title: "Address",
  },
  {
    field: "loan_amount",
    title: "Loan Amount",
  },
  {
    field: "next_due_date",
    title: "Next Due Date",
  },
  {
    field: "status",
    title: "Status",
    Cell: (props) => <StatusChip props={props} />,
  },
  {
    field: "action",
    title: "Action",
  },
];
export const gridColumns_reportsAndDocuments = [
  {
    field: "report_or_workbook",
    title: "report_or_workbook",
  },
  {
    field: "delivery_date",
    title: "delivery_date",
  },
  {
    field: "delivery_method",
    title: "delivery_method",
  },
  {
    field: "emails",
    title: "emails",
  },
  {
    field: "next_report_run_on",
    title: "next_report_run_on",
  },
  {
    field: "report_runs_left",
    title: "report_runs_left",
  },
  {
    field: "action",
    title: "action",
  },
];
export const gridColumns_scheduledReports = [
  {
    title: "Name",
    field: "report_custom_name",
    style: { width: "20%", wordBreak: "break-all" },
    Cell: (props) => <NavigateButtonForScheduleReport props={props} />,
  },
  {
    title: "Date",
    field: "date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    title: "Time",
    field: "time",
  },
  {
    title: "Repeat",
    field: "repeat",
    Cell: ({ value }) => <div>{value == "true" ? "Yes" : "No"}</div>,
  },
  {
    title: "Frequency",
    field: "frequency",
    Cell: (props) => <HandleFrequency props={props} />,
  },
  {
    title: "Last Run Date",
    field: "last_run_date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    title: "Next Run Date",
    field: "next_run_date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    title: "Report Format",
    field: "reportFormat",
  },
  {
    title: "Delivery Method",
    field: "deliveryMethord",
  },
  {
    title: "Is Active?",
    field: "is_active_main",
     Cell: ({ value }) => <div>{value == "Y" ? "Yes" : "No"}</div>,
  },
  {
    title: "Delete",
    field: "delete",
    Cell: (props) => <DeleteScheduleButton props={props} />,
  },
];
export const gridColumns_saveReports = [
  {
    title: "Name",
    field: "report_custom_name",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    title: "Report Name",
    field: "reportName",
    Cell: (props) => <NavigateButton props={props} />,
  },
  {
    title: "Favorite",
    field: "is_favorite",
  },
  {
    title: "Delete",
    field: "delete",
    Cell: (props) => <DeleteSavedButton props={props} />,
  },
];
export const gridColumns_deliveredReports = [
  {
    field: "receiver_name",
    title: "receiver_name",
  },
  {
    field: "user_email",
    title: "user_email",
  },
  {
    field: "time_sent",
    title: "time_sent",
  },
  {
    field: "delivery_method",
    title: "delivery_method",
  },
  {
    field: "next_schedule",
    title: "next_schedule",
  },
  {
    field: "action",
    title: "action",
  },
];
export const gridColumns_DefaultManagementCommon = [
  {
    field: "account",
    title: "Loan Acc",
    Cell: (props) => <LoanAccCustomCell props={props} />,
  },
  {
    field: "Borrower Name",
    title: "Details",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "Property Address",
    title: "Street",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
];
export const gridColumns_DefaultManagement31DaysPast = [
  {
    title: "Loan Acc",
    field: "loan_account",
    Cell: (props) => <LoanAccCustomCell props={props} />,
  },
  {
    title: "Details",
    field: "FullName",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    title: "Defaulted by days",
    field: "days_late",
    Cell: ({ value }) => (
      <span style={{ color: value < 0 ? "red" : "" }}>
        {value < 0
          ? `${daysToMonthsAndDaysV2(value)}`
          : daysToMonthsAndDaysV2(value)}
      </span>
    ),
  },
];
export const gridColumns_loansInForeclosure = [
  {
    field: "loan_acc",
    title: "loan_acc",
  },
  {
    field: "street",
    title: "street",
  },
  {
    field: "location",
    title: "location",
  },
];
export const gridColumns_loansInWorkout = [
  {
    field: "loan_acc",
    title: "loan_acc",
  },
  {
    field: "street",
    title: "street",
  },
  {
    field: "location",
    title: "location",
  },
];
export const gridColumns_loansInBankruptcy = [
  {
    field: "loan_account",
    title: "loan_acc",
    Cell: (props) => <LoanAccCustomCell props={props} />,
  },
  {
    field: "street",
    title: "street",
  },
  {
    field: "location",
    title: "location",
  },
];
export const gridColumns_paymentActivity = [
  { field: "Loan_account", title: "Loan Account", style: { width: "10%", wordBreak: "break-all" } },
  {
    field: "Property_Address",
    title: "Property Address",
    style: { width: "15%", wordBreak: "break-all" },
  },
  { field: "date", title: "Date" },
  { field: "due_date", title: "Due Date" },
  {
    field: "reference",
    title: "Reference",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "payment_code",
    title: "Payment Code",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "description",
    title: "Description",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "to_reserve",
    title: "To Reserve",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "principal",
    title: "Principal",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "interest",
    title: "Interest",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "other",
    title: "Other",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "amount",
    title: "Amount",
    Cell: (props) => <DollarConvert props={props} />,
  },
];
export const gridColumnsTrustLedsgerReserve = [
  { field: "Date", title: "Date" },
  { field: "Reference", title: "Reference" },
  { field: "From Whom Received", title: "From Whom Received" },
  { field: "Memo", title: "Memo" },
  {
    field: "Payment",
    title: "Payment",
    Cell: (props) => <DollarConvert props={props} />,
  },
];
export const gridColumns_PastPaymentsToLender = [
  { field: "Check Date", title: "Check Date" },
  {
    field: "Check Number",
    title: "Check Number",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "Principal",
    title: "Principal",

    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "Interest",
    title: "Interest",

    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "Servicing Fee",
    title: "Servicing Fee",

    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "Late Charge",
    title: "Late Charge",

    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "Other",
    title: "Other",

    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "Amount",
    title: "Amount",

    Cell: (props) => <DollarConvert props={props} />,
  },
];

export const gridColumns_activeLoanSnapshot = [
  {
    field: "account",
    title: "Account",
    Cell: (props) => <LoanAccCustomNewTabCell props={props} keyStr="account" />,
  },
  {
    field: "borrower_name",
    title: "Borrower Name",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "origbal",
    title: "Original Balance",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "principal",
    title: "Principal",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "property_address",
    title: "Property Address",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    title: "Investors Rate",
    field: "noterate",
    Cell: (props) => <PercentageConvert props={props} />,
  },
  { title: "Next Due Date", field: "next_due_date" },
  {
    title: "Insurance Monitoring",
    field: "insurance_info",
    // Cell: (props) => <img src={props?.value} width="40" alt="" />,
    // Cell: (props) => <span>{props?.value?.contains('Pending')?'pending':props?.value?.contains('green')?'green':'yellow'}</span>,
    Cell: (props) => <InsuranceMonitoringBadge props={props} />,
  },
  {
    title: "Time to Maturity",
    field: "days_to_maturity",
    Cell: ({ value }) => (
      <span style={{ color: value < 0 ? "red" : "" }}>
        {value < 0
          ? `${daysToMonthsAndDaysV2(value)}`
          : daysToMonthsAndDaysV2(value)}
      </span>
    ),
  },
];
export const gridColumns_attatchment = [
  {
    field: "Attachment",
    title: "Attachment",
    Cell: (props) => (
      <a href={props.value.hrefValue + "/1"}>{props.value.titleValue}</a>
    ),
  },
  { field: "Date", title: "Date" },
];
export const gridColumns_attatchmentBorrower = [
  {
    field: "updatedAttachment",
    title: "Attachment",
    Cell: ({ value }) => <AttachmentCell value={value} />,
  },
  { field: "Date", title: "Date" },
];
export const gridColumns_activeLoanSnapshotNoResidual = [
  { field: "Borrower Name", title: "Borrower Name" },
  {
    field: "Lender Principal Investment",
    title: "Lender Principal Investment",
  },
  {
    field: "Loan Account",
    title: "Loan Account",
    Cell: (props) => (
      <LoanAccCustomNewTabCell props={props} keyStr="Loan Account" />
    ),
  },
  { title: "Investors Rate", field: "noterate" },
  // { field: "LoanRecID", title: "LoanRecID" },
  { field: "Next Due Dates", title: "Next Due Dates" },
  {
    field: "insurance_info",
    title: "Insurance Monitoring",
    Cell: (props) => <InsuranceMonitoringBadge props={props} />,
  },
  {
    title: "Time to Maturity",
    field: "days_to_maturity",
    Cell: ({ value }) => (
      <span style={{ color: value < 0 ? "red" : "" }}>
        {value < 0
          ? `${daysToMonthsAndDaysV2(value)}`
          : daysToMonthsAndDaysV2(value)}
      </span>
    ),
  },
];
export const gridColumnAdminMenu = [
  {
    field: "first_name",
    title: "First Name",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "last_name",
    title: "Last Name",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  // {
  //   field: "username",
  //   title: "Username",
  //   style: { width: "10%", wordBreak: "break-all" },
  //   Cell: (props) => (
  //     <div role="button" className={"linkClick"}>
  //       {props?.value}
  //     </div>
  //   ),
  // },
  {
    field: "role_name",
    title: "Role",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "account_name",
    title: "Account Name",
    style: { width: "20%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "email",
    title: "Email",
    style: { width: "20%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  // {
  //   field: "user_id",
  //   title: "User Id",
  //   style: { width: "10%", wordBreak: "break-all" },
  // },
  {
    field: "status",
    title: "Activated",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: ({ value }) => (value === "Y" ? "Yes" : "No"),
  },
  {
    field: "status2",
    title: "Edit",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: (props) => <EditMenu props={props} />,
  },
  // {
  //   field: "masquerade",
  //   title: "Masquerade",
  //   style: { width: "15%", wordBreak: "break-all" },
  //   Cell: (props) => <MasqueradeButton props={props} />,
  // },
];
export const gridColumns_additionalInterestSkim = [
  {
    // field: "loan_account",
    field: "account",
    title: "Loan Acc",
    // style: { width: "12%", wordBreak: "break-all" },
    Cell: (props) => (
      <LoanAccCustomNewTabCell props={props} keyStr="loan_account" />
    ),
  },
  {
    field: "borrower",
    title: "Borrower",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "servicing_fee_monthly",
    title: "Servicing Fee (Monthly)",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "daily_per_diem",
    title: "Daily (Per Diem)",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "BilledThrough",
    title: "Billed Through",
    Cell: ({ value }) => (value ? <span>{value}</span> : "-"),
  },
  {
    field: "NextDuedate",
    title: "Next Due Date",
    Cell: (props) => <DateConvert props={props} />,
  },
];
export const gridColumns_ticket = [
  {
    field: "id",
    title: "Incident Id",
    style: { width: "5%", wordBreak: "break-all" },
    Cell: ({ row }) => <IncidentIdCustomCell props={row} />,
  },
  {
    field: "created",
    title: "Age",
    style: { width: "5%", wordBreak: "break-all" },
    Cell: ({ value }) => {
      const daysOld = calculateDaysOld(value);
      if (daysOld < 1) {
        return <Dot color="green" />;
      } else if (daysOld >= 1 && daysOld < 8) {
        return <Dot color="yellow" />;
      } else {
        return <Dot color="red" />;
      }
    },
  },
  {
    field: "assignee",
    title: "Assignee",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: ({ value }) => {
      if (!value) {
        return "Unassigned";
      } else {
        return <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>;
      }
    },
  },
  {
    field: "product_name",
    title: "Department",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  // {
  //   field: "severity_name",
  //   title: "Severity Name",
  //   style: { width: "10%", wordBreak: "break-all" },
  // },
  {
    field: "status",
    title: "Status",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "subject",
    title: "Subject",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
];
export const gridColumns_maturity_override = (updateMyData) => [
  {
    field: "Lender_Acct",
    title: "Lender Account",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Loan_Acct",
    title: "Loan Account",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "FullName",
    title: "Full Name",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "maturity_date",
    title: "Maturity Date",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Frequency",
    title: "Frequency",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Service_Status",
    title: "Service Status",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "ACH_DebitAmount",
    title: "ACH Debit Amount",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "updateDate",
    title: "Update Date",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: ({ row, value }) => {
      return (
        <input
          type="date"
          className="form-control input-lg p-5"
          onChange={(e) =>
            updateMyData(row.index, "updateDate", e.target.value)
          }
          value={value || new Date().toISOString().substr(0, 10)}
        />
      );
    },
  },
];
export const gridColumns_LoanCharges = [
  {
    field: "Loan Account",
    // field: "Account",
    title: "Loan Acc",
    style: { width: "15%", wordBreak: "break-all" },
    // Cell: ({ value }) => (
    //   <BlurWrapper>
    //     <span>{value}</span>
    //   </BlurWrapper>
    // ),
    Cell: (props) => <LoanAccCustomCellParentRecID props={props} />,
  },
  {
    field: "Date",
    title: "Date",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Reference",
    title: "Reference",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: ({ value }) => (
      <BlurWrapper>
        <span>{value}</span>
      </BlurWrapper>
    ),
  },
  {
    field: "Description",
    title: "Description",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: ({ value }) => (
      <BlurWrapper>
        <span>{value}</span>
      </BlurWrapper>
    ),
  },
  {
    field: "Interest Rate",
    title: "Interest Rate",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Interest From",
    title: "Interest From",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "Deferred",
    title: "Deferred",
    style: { width: "10%", wordBreak: "break-all" },
  },
  // {
  //   field: "Owed to Account",
  //   title: "Owed to Account",
  //   style: { width: "10%", wordBreak: "break-all" },
  //   Cell: ({ value }) => (
  //     <div >{extractTextFromRTF(value)}</div>
  //   ),
  // },
  // {
  //   field: "On Behalf Of",
  //   title: "On Behalf Of",
  //   style: { width: "10%", wordBreak: "break-all" },
  // },
  {
    field: "Unpaid Balance",
    title: "Unpaid Balance",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: (props) => <DollarConvert props={props} />,
  },
];
export const gridColumns_loanFunding = [
  {
    field: "lender_account",
    title: "Lender Account",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "lender_name",
    title: "Lender Name",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "lender_Phone",
    title: "Lender Phone",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "lender_EmailAddress",
    title: "Lender Email Address",
    Cell: ({ value }) => (
      <BlurWrapperWithSpan>
        <p style={{ wordBreak: "break-all" }}>{value}</p>
      </BlurWrapperWithSpan>
    ),
  },
  {
    field: "fees",
    title: "Fees",
    Cell: ({ value }) => {
      const data = extractTextFromRTF(value);
      return (
        <BlurWrapperWithSpan>
          <div>{data}</div>
        </BlurWrapperWithSpan>
      );
    },
  },
  {
    field: "lender_rate",
    title: "Lender Rate",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "noterate",
    title: "Note Rate",
    Cell: (props) => <PercentageConvert props={props} />,
  },
  {
    field: "pct_owned",
    title: "Percent Owned",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "principal_balance",
    title: "Principal Balance",
  },
  { field: "regular_payment", title: "Regular Payment" },
  {
    field: "soldrate",
    title: "Sold Rate",
    Cell: (props) => <PercentageConvert props={props} />,
  },
  // { field: "rounding_error", title: "Rounding Error" },
];
export const revYTDHeaders = [
  { title: "Revenue Source", field: "categoryName" },
  { title: "Amount", field: "amount" },
  { title: "Percent", field: "percent" },
];
export const loanDistByPriorityHeader = [
  { title: "Priority", field: "priority" },
  { title: "Count", field: "count" },
  { title: "Amount", field: "amount" },
  { title: "Percent", field: "percent" },
];
export const loanDistByMaturityHeader = [
  { title: "Year", field: "year" },
  { title: "Count", field: "count" },
  { title: "Amount", field: "amount" },
  { title: "Percent", field: "percent" },
];
export const loanAgingHeader = [
  { title: "Days Overdue", field: "categoryName" },
  { title: "Count", field: "count" },
  {
    title: "Amount",
    field: "amount",
    Cell: (props) => <DollarConvert props={props} />,
  },
  { title: "Percent", field: "percent" },
];
export const loanDistByPropTypeHeader = [
  {
    title: "Property Type",
    field: "propertyType",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  { title: "Count", field: "count" },
  { title: "Amount", field: "amount" },
  { title: "Percent", field: "percent" },
];
export const loanDistByPrinBalHeader = [
  {
    title: "Lender Account",
    field: "Lender Account",
    style: { width: "40%", wordBreak: "break-all" },
    Cell: (props) => {
      const navigate = useNavigate();
      const dispatch = useDispatch();
      const row = props?.row?.original;
      return (
        <div
          role={"button"}
          onClick={() => {
            dispatch(
              setPieSelected({
                title: "Loan Distribution by Investor",
                value: row["Lender Account"],
                brokerLenderId: row["Lender ID"],
              }),
            );
            navigate("/pie-chart-details", {
              state: {
                title: "Loan Distribution by Investor",
                value: row["Lender Account"],
                brokerLenderId: row["Lender ID"],
              },
            });
          }}
        >
          <svg
            width="10"
            height="10"
            fill={backgroundColors[Math.floor(Math.random() * 10)]}
          >
            <rect width="10" height="10" />
          </svg>{" "}
          <BlurWrapperWithSpan>
            <span
              style={{
                display: "inline-block",
                color: "#438ffe",
                border: "none",
                borderBottom: "1px solid currentColor",
              }}
            >
              {" "}
              {props.value}
            </span>
          </BlurWrapperWithSpan>
        </div>
      );
    },
  },
  { title: "Count", field: "Total" },
  {
    title: "Percent",
    field: "SumOfPrinBalPer",
    Cell: (props) => <div>{Number(props?.value).toFixed(2)}%</div>,
  },
  {
    title: "Amount",
    field: "amount",
    Cell: (props) => <DollarConvert props={props} />,
  },
];
export const wLTVByPropTypeHeader = [
  { title: "Property Type", field: "propertyType" },
  { title: "Amount", field: "amount" },
];
export const piedata = [
  { amount: 10, percent: 10, revenueSource: "Interest" },
  { amount: 10, percent: 10, revenueSource: "Servicing Fees" },
  { amount: 10, percent: 10, revenueSource: "Late Charges" },
  { amount: 10, percent: 10, revenueSource: "Prepays" },
  { amount: 10, percent: 10, revenueSource: "Other Fees" },
  { amount: 10, percent: 10, revenueSource: "" },
];
export const gridColumns_MeterDetails = (isABorrower = false) => {
  return [
    {
      title: "Loan Account",
      field: "Account",
      Cell: (props) => (
        <LoanAccCustomCellForPropertyInfo
          props={props}
          isABorrower={isABorrower}
        />
      ),
    },
    {
      title: "Full Name",
      field: "FullName",
      Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
    },
    // {
    //   field: "InsAgentNameSl$D3v@75",
    //   title: "Insurance Agent Name",
    // },
    {
      field: "InsDescription",
      title: "Description",
      Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
    },
    // {
    //   field: "PrinBal",
    //   title: "YTD PrinBal",
    // },
    // {
    //   field: "InsAgentAddress",
    //   title: "Insurance Agent Address",
    //   Cell: ({ value }) => <RtfViewer rtfContent={value} />,
    // },
    // {
    //   field: "InsAgentPhone",
    //   title: "Insurance Agent Phone",
    // },
    {
      field: "InsCoverage",
      title: "Insurance Coverage",
      Cell: (props) => <DollarConvert props={props} />,
    },
    {
      field: "InsExpiration",
      title: "Insurance Expiration",
      Cell: (props) => <DateConvert props={props} />,
    },
    // {
    //   field: "InsInsuredName",
    //   title: "Insurance Insured Name",
    // },
    // {
    //   field: "InsPolicyNo",
    //   title: "Insurance Policy Number",
    // },
    // {
    //   field: "LastName",
    //   title: "Last Name",
    // },
    {
      field: "Lender Principal Investment",
      title: "Lender Principal Investment",
      Cell: (props) => <DollarConvert props={props} />,
    },
    // {
    //   field: "OrigBal",
    //   title: "Original Balance",
    //   Cell: (props) => <DollarConvert props={props} />,
    // },
    // {
    //   field: "Priority",
    //   title: "Priority",
    // },
    // {
    //   field: "PropAddress",
    //   title: "Property Address",
    // },
    // {
    //   field: "SortName",
    //   title: "Sort Name",
    // },
  ];
};

export const gridColumns_PortfolioBalancePie = [
  {
    field: "loanAccount",
    title: "Loan Account",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: (props) => <LoanAccCustomCell props={props} />,
  },
  {
    field: "amount",
    title: "Loan Amount",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: (props) => <DollarConvert props={props} />,
  },
];
export const gridColumns_ReservesLoanDetails = [
  {
    field: "Date",
    title: "Date",
  },
  {
    field: "Reference",
    title: "Reference",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "From Whom Received",
    title: "From Whom Received / Paid",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "Memo",
    title: "Memo",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },

  {
    field: "Payment",
    title: "Payment",
  },
  {
    field: "Clr",
    title: "Clr",
  },
  {
    field: "Deposit",
    title: "Deposit",
  },
  {
    field: "Balance",
    title: "Balance",
  },
];

export const gridColumns_RolesMenu = [
  {
    field: "role_name",
    title: "Role Name",
  },
  // {
  //   field: "role_type",
  //   title: "Role Type",
  // },
  {
    field: "is_active",
    title: "Is Active",
    Cell: ({ value }) => (value === "Y" ? "Yes" : "No"),
  },
  {
    field: "role_description",
    title: "Role Description",
  },
  {
    field: "Edit",
    title: "Edit",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: (props) => {
      const navigate = useNavigate();
      return (
        <button
          className="btn btn-primary text-white"
          onClick={() =>
            navigate(`/role-menu/Update/${props?.row?.original?.role_id}`)
          }
          disabled={props?.row?.original?.type === "D"}
        >
          Edit
        </button>
      );
    },
  },
];
export const gridColumns_dossDocc = [
  { field: "application_id", title: "Application ID" },
  { field: "source", title: "Source" },
  { field: "username", title: "User Name" },
  { field: "usercompany", title: "User Company" },
  { field: "useremail", title: "User Email" },
  { field: "lendername", title: "Lender Name" },
  { field: "lenderofficer", title: "Lender Officier" },
  { field: "maturitydate", title: "Maturity Date" },
  {
    field: "Edit",
    title: "Edit",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: (props) => {
      const navigate = useNavigate();
      return (
        <button
          className="btn btn-primary text-white"
          onClick={() =>
            navigate(
              `/dossdoc/edit/${props?.row?.original?.doc_id}/${props?.row?.original?.application_id}`,
            )
          }
        >
          Edit
        </button>
      );
    },
  },
];

export const gridColumns_dossDoccAttachments = [
  { field: "filename", title: "File Name" },
  { field: "file_comments", title: "File Comments" },
  { field: "creation_date", title: "Date Added" },
  { field: "created_by", title: "Created By" },
  {
    field: "file_path",
    title: "Download",
    style: { wordBreak: "break-all" },
    Cell: ({ row }) => (
      <a
        href={row.original.file_path}
        target="_blank"
        rel="noopener noreferrer"
      >
        {row.original.file_path}
      </a>
    ),
  },
];
export const gridColumnsLenderOnboarding = [
  {
    field: "name",
    title: "Company Name",
  },
  {
    field: "firstName",
    title: "First Name",
  },
  {
    field: "email",
    title: "Email",
  },
  {
    field: "status",
    title: "Status",
  },
  // {
  //   field: "Edit",
  //   title: "Edit",
  //   style: { width: "10%", wordBreak: "break-all" },
  //   Cell: (props) => {
  //     const navigate = useNavigate();
  //     return (
  //       <button
  //         className="btn btn-primary"
  //         onClick={() =>
  //           navigate(`/lender-onboard/Update/${props?.row?.original?.jsonId}`)
  //         }
  //       >
  //         Edit
  //       </button>
  //     );
  //   },
  // },
];

export const gridColumns_demandPayoff = [
  {
    field: "loan_number",
    title: "Loan Number",
    Cell: (props) => <PayOffCustomCell props={props} />,
  },
  {
    field: "fullname",
    title: "Full Name",
  },
  {
    field: "property_address",
    title: "Property Address",
  },

  {
    field: "payoff_good_through_date",
    title: "Payoff Good Through Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "demand_expiration_date",
    title: "Demand Expiration Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  // {
  //   field: "payoff_amount",
  //   title: "Payoff Amount",
  //   Cell: (props) => <DollarConvert props={props} />,
  // },
  {
    field: "principal_balance",
    title: "Principal Balance",
    Cell: (props) => <DollarConvert props={props} />,
  },

  // {
  //   field: "CalculatedPayoff",
  //   title: "Calculated Payoff",
  // },
  {
    field: "status",
    title: "Status",
  },
  {
    field: "creation_date",
    title: "Creation Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "created_by",
    title: "Created By",
  },
  {
    field: "last_update_date",
    title: "Last Update Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "last_updated_by",
    title: "Last Updated By",
  },
];

export const gridColumns_PayoffCharges = [
  { field: "chargeType", title: "Charge Type" },
  { field: "description", title: "Description" },
  { field: "amount", title: "Amount" },
];

export const gridColumns_PayoffFee = [
  { field: "FeeDescription", title: "Fee Description" },
  { field: "FeeAmount", title: "Fee Amount" },
];

export const gridColumns_notes = [
  {
    field: "note_id",
    title: "Note Id",
    style: { width: "5%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "note",
    title: "Note",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "recid",
    title: "Recid",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "creation_date",
    title: "Creation Date",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "created_by",
    title: "Created By",
    style: { width: "15%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "last_update_date",
    title: "Last Update Date",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "last_updated_by",
    title: "Last Updated By",
    style: { width: "15%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
];

export const gridColumns_conversationLog = [
  // {
  //   field: "parentrecid",
  //   title: "Parent Recid",
  //   style: { width: "22%", wordBreak: "break-all" },
  // },
  {
    // field: "calldate",
    field: "CallDate",
    title: "Date Called",
  },
  {
    // field: "calltype",
    field: "CallType",
    title: "Call Type",
    // Cell: ({ value }) => <span>{value === 0 ? "Incoming" : "Outgoing"}</span>,
  },
  {
    // field: "callperson",
    field: "CallPerson",
    title: "Contact Name",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    // field: "subject",
    field: "Subject",
    title: "Subject",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    // field: "memotext",
    field: "MemoText",
    title: "Content",
    Cell: ({ value }) => <RtfViewer rtfContent={value} />,
    // Cell: ({ value }) =>
    //   value
    //     .replace(/<[^>]+>/g, "")
    //     .replace(/&nbsp;/g, " ")
    //     .replace(/&amp;/g, "&")
    //     .trim(),
    style: { width: "30%", wordBreak: "break-all" },
    shouldWrap: true,
  },
  {
    // field: "followup",
    field: "FollowUp",
    title: "Follow Up?",
    Cell: ({ value }) => (
      <BlurWrapperWithSpan>{value ? value : "-"}</BlurWrapperWithSpan>
    ),
  },
  {
    // field: "followupname",
    field: "FollowUpName",
    title: "Assigned To",
    Cell: ({ value }) => (
      <BlurWrapperWithSpan>{value ? value : "-"}</BlurWrapperWithSpan>
    ),
  },
  {
    // field: "followupdate",
    field: "FollowUpDate",
    title: "Follow Up Date",
    Cell: ({ value }) => (
      <BlurWrapperWithSpan>{value ? value : "-"}</BlurWrapperWithSpan>
    ),
  },
  // {
  //   field: "completed",
  //   title: "Completed?",
  //   Cell: ({ value }) => <ExtractValue value={value} />,
  // },
  // {
  //   field: "completedname",
  //   title: "Completed By",
  // },
  // {
  //   field: "completeddate",
  //   title: "Completed Date",
  // },
];

export const gridColumns_Borrower_Payoff_Details = [
  {
    field: "loan_number",
    title: "Loan Number",
    Cell: (props) => <LoanAccCustomCell props={props} borrower={true} />,
  },
  {
    field: "fullname",
    title: "Full Name",
  },
  {
    field: "payoff_good_through_date",
    title: "Payoff Good Through Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "demand_expiration_date",
    title: "Demand Expiration Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "payoff_amount",
    title: "Payoff Amount",
    Cell: (props) => <DollarConvert props={props} />,
  },

  {
    field: "property_address",
    title: "Property Address",
  },
  {
    field: "principal_balance",
    title: "Principal Balance",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "status",
    title: "Status",
  },
];

export const gridColumns_Borrower_Bank_Accounts = (setStatus) => {
  return [
    {
      field: "account_name",
      title: "Account Name",
    },
    {
      field: "account_number",
      title: "Account Number",
      Cell: ({ value }) => {
        const maskedValue = value?.replace(/\d(?=\d{4})/g, "•");
        return <div>{maskedValue}</div>;
      },
    },
    {
      // field: "ach_individualname",
      field: "ach_individualname",
      title: "ACH Individual Name",
    },
    {
      // field: "nick_name",
      field: "nick_name",
      title: "Account Nick Name",
    },
    {
      field: "routing_number",
      title: "Routing Number",
    },
    {
      field: "delay_allowed",
      title: "Action",
      Cell: (props) => {
        const { deleteBankAccount } = useDeleteBankAccount();
        const navigate = useNavigate();
        const disabled =
          props?.row?.original?.delay_allowed?.toLowerCase() !== "y";

        return (
          <div className="d-flex justify-content-start align-items-center gap-3">
            <OverlayTrigger
              placement="top"
              overlay={
                disabled ? (
                  <Tooltip id="disabled-tooltip-edit">
                    This account cannot be edited or deleted because it is tied
                    to a loan ACH info.
                  </Tooltip>
                ) : (
                  <></>
                )
              }
            >
              <span className="d-inline-block">
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() =>
                    navigate(
                      `/update-bank-account/${props.row.original.usr_ext_id}`,
                    )
                  }
                  className="shadow-sm"
                  disabled={disabled}
                >
                  <Pencil size={14} />
                </Button>
              </span>
            </OverlayTrigger>
            <DeleteButton
              icon={
                <div className="btn btn-outline-error btn-sm shadow-sm">
                  <Trash size={16} />
                </div>
              }
              onClick={() =>
                deleteBankAccount(props?.row?.original?.usr_ext_id, setStatus)
              }
              disable={disabled}
            />
          </div>
        );
      },
    },
  ];
};

export const gridColumns_PortfolioAtGlanceBorrower = [
  {
    field: "account",
    title: "Loan Acc",
    style: { width: "15%", wordBreak: "break-all" },
    Cell: (props) => <LoanAccCustomCell props={props} borrower={true} />,
  },
  {
    field: "loan_info",
    title: "Loan Info",
    style: { width: "20%", wordBreak: "break-all" },
  },
  {
    field: "next_due_date",
    title: "Next due date",
    style: { width: "10%", wordBreak: "break-all" },
  },
  // {
  //   field: "ytd_interest",
  //   title: "YTD Interest",
  //   style: { width: "10%", wordBreak: "break-all" },
  // },
  {
    field: "maturity_date",
    title: "Maturity Date",
    style: { width: "10%", wordBreak: "break-all" },
  },
  // {
  //   field: "maturity_date",
  //   title: "Time to Maturity",
  //   style: { width: "10%", wordBreak: "break-all" },
  // },
  {
    field: "days_to_maturity",
    title: "Time to Maturity",
    style: { width: "13%", wordBreak: "break-all" },
    Cell: ({ value }) => (
      <span style={{ color: value < 0 ? "red" : "" }}>
        {value < 0
          ? `${daysToMonthsAndDaysV2(value)}`
          : daysToMonthsAndDaysV2(value)}
      </span>
    ),
  },
  {
    title: "Insurance Monitoring",
    field: "insurance_info",
    // Cell: (props) => <img src={props?.value} width="40" alt="" />,
    Cell: (props) => <InsuranceMonitoringBadge props={props} borrower={true} />,
    // Cell: (props) => <span>{props?.value.contains("Pending")?"pending":"green"}</span>,
    // Cell: (props) => {

    //   // if(typeof(props.value)=='string')
    //   // return <span>{props?.value.contains("Pending")?"pending":"green"}</span>
    //   return <span>not given</span>;
    // },
    style: { width: "15%", wordBreak: "break-all" },
  },

  // {
  //   field: "principal",
  //   title: "Principal Ion",
  //   style: { width: "10%" },
  //   Cell: (props) => <DollarConvert props={props} />,
  // },
  {
    field: "principal",
    title: "Lender Principal Investment",
    style: { width: "15%" },
    Cell: (props) => <DollarConvert props={props} />,
  },
];

export const gridColumns_PayoffCalculator = [
  {
    field: "accrued_interest",
    title: "Accrued Interest",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "default_interest",
    title: "Default Interest",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "late_charges",
    title: "Late Charges",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "other_fees",
    title: "Other Fees",
    Cell: (props) => <DollarConvert props={props} />,
  },

  {
    field: "other_payments",
    title: "Other Payments",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "payoff_amt",
    title: "Payoff Amount",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "prepayment_penalties",
    title: "Prepayment Penalties",
    Cell: (props) => <DollarConvert props={props} />,
  },

  {
    field: "principal_balance",
    title: "Principal Balance",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "trust_balance",
    title: "Trust Balance",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "unpaid_charges",
    title: "Unpaid Charges",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "unpaidinterest",
    title: "Unpaid Interest",
    Cell: (props) => <DollarConvert props={props} />,
  },
];

export const gridColumns_SummaryPage = [
  {
    field: "loanAccount",
    title: "Loan Account",
  },
  {
    field: "propertyAddress",
    title: "Property Address",
  },
  {
    field: "loanOption",
    title: "Option",
    Cell: ({ value }) => {
      if (value === "RP") {
        return <div>Regular Payment</div>;
      } else if (value === "PP") {
        return <div>Principal Pay Down</div>;
      } else if (value === "OF") {
        return <div>Other Fees and Charges</div>;
      }
    },
  },
  {
    field: "selectedPaymentDayLoan",
    title: "Select Payment Day",
  },
  {
    field: "selectedReportLoan",
    title: "Frequency",
    Cell: ({ value }) => {
      if (value === "0") {
        return <div>Only Once</div>;
      } else if (value === "1") {
        return <div>Monthly</div>;
      }
    },
  },
  {
    field: "achDebitAmount",
    title: "ACH Debit Amount",
    Cell: (props) => <DollarConvert props={props} />,
  },

  // {
  //   field: "achDebitAmount",
  //   title: "ACH Debit Amount",
  // },
  {
    field: "scheduledPaymentStatus",
    title: "Scheduled Payment Status",
    Cell: ({ value }) => {
      if (value === "1") {
        return <div>Active</div>;
      } else if (value === "2") {
        return <div>Inactive</div>;
      }
    },
  },
  {
    field: "selectedDate",
    title: "Scheduled Payment Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "selectedBankAccountLoan",
    title: "Debit From",
  },
];

export const gridColumns_LoansMaturing = [
  {
    field: "account",
    title: "Loan Acc",

    Cell: (props) => <LoanAccCustomCell props={props} borrower={true} />,
  },
  {
    field: "nextDueDate",
    title: "Next Due Date",

    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "maturityDate",
    title: "Maturity date",

    Cell: (props) => <DateConvert props={props} />,
  },
];

export const gridColumns_InsuranceExpiringWithin30Days = [
  {
    field: "account",
    title: "Loan Acc",
    Cell: (props) => <LoanAccCustomCell props={props} borrower={true} />,
  },
  {
    title: "Full Name",
    field: "fullName",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },

  {
    field: "description",
    title: "Description",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },

  {
    field: "coverage",
    title: "Insurance Coverage",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "expirationDate",
    title: "Insurance Expiration",
    Cell: (props) => <DateConvert props={props} />,
  },
];

export const gridColumns_ScheduledOneTimePayments = (handleDelete) => {
  return [
    {
      field: "loan_account_number",
      title: "Loan Account",
      Cell: (props) => <LoanAccCustomCellForBorrowers props={props} />,
    },
    {
      field: "amount",
      title: "Amount",
      Cell: (props) => <DollarConvert props={props} />,
    },
    {
      field: "date_issued",
      title: "Date Issued",
      Cell: (props) => <DateConvert props={props} />,
    },
    {
      field: "ach_id",
      title: "Action",
      Cell: (props) => {
        const ach_id = props?.row?.original?.ach_id;
        if (ach_id) {
          return <DeleteButton onClick={() => handleDelete(ach_id)} />;
        } else {
          return <DeleteButton disable={true} />;
        }
      },
    },
  ];
};

export const gridColumns_OneTimePastPayments = () => [
  {
    field: "loan_account_number",
    title: "Loan Account",
    Cell: (props) => <LoanAccCustomCellForBorrowers props={props} />,
  },
  {
    field: "amount",
    title: "Amount",
    Cell: (props) => <DollarConvert props={props} />,
  },
  {
    field: "date_issued",
    title: "Date Issued",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "cheque_number",
    title: "Cheque Number",
  },
];

export const vomColumnsDefs = (navigate, email, isExternalBorrower = false) => [
  {
    field: "request_id",
    title: "View",
    Cell: ({ value, ...props }) => {
      const path = `/vom-details/${value}/${email}`;
      // props?.row?.original?.borrower_yn === "Y"
      //   ? `/vom-details/external/${value}/${email}`
      //   : `/vom-details/${value}/${email}`;
      return (
        <Button
          // variant="link"
          className="p-3 btn btn-primary w-100"
          onClick={() => navigate(path)}
        >
          View
        </Button>
      );
    },
  },
  {
    field: "loan_number",
    title: "Loan Account",
  },
  {
    field: "request_date",
    title: "Request Received Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  // {
  //   field: "expected_delivery_date",
  //   title: "Expected Delivery Date",
  // },
  {
    field: "request_number",
    title: "Request Number",
  },
  {
    field: "status",
    title: "Status",
  },
];

export const vomColumnsDefsForBorrower = (navigate) => [
  {
    field: "request_id",
    title: "View",
    Cell: ({ value }) => (
      <Button
        // variant="link"
        className="p-3 btn btn-primary w-100"
        onClick={() => navigate(`/vom-details/${value}`)}
      >
        View
      </Button>
    ),
  },
  {
    field: "account_number",
    title: "Loan Account",
  },
  {
    field: "request_date",
    title: "Request Received Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "REQUEST_NUMBER",
    title: "Request Number",
  },
  // {
  //   field: "expected_delivery_date",
  //   title: "Expected Delivery Date",
  // },
  {
    field: "status",
    title: "Status",
  },
];

const FREQUENCY_MAP = {
  D: "Daily",
  W: "Weekly",
  M: "Monthly",
};

const DeleteTrigger = ({ loading, action, onClick }) => {
  const [show, setShow] = useState(false);

  const handleCancel = () => {
    setShow(false);
  };

  const handleDelete = () => {
    setShow(false);
    onClick();
  };

  return (
    <OverlayTrigger
      trigger="click"
      placement="top"
      show={show}
      onToggle={setShow}
      overlay={
        <Popover id="popover-basic">
          <Popover.Header as="h3" style={{ background: "#fff0f0" }}>
            Delete report?
          </Popover.Header>

          <Popover.Body>
            Are you sure you want to delete this? This action cannot be undone.

            <div className="d-flex mt-5 justify-content-between mb-3">
              <button
                className="btn btn-error btn-sm"
                onClick={handleDelete}
              >
                Delete
              </button>

              <button
                className="btn btn-grey btn-sm"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </Popover.Body>
        </Popover>
      }
    >
      <button
        style={{
          border: "none",
          background: "#fff0f0",
          color: "#d63031",
          borderRadius: "6px",
          padding: "6px 10px",
          fontSize: "12px",
          fontWeight: 500,
        }}
        disabled={loading}
      >
        {loading && action === "delete" ? (
          <div
            style={{ height: "1.2rem", width: "1.2rem" }}
            className="spinner-border"
            role="status"
          />
        ) : (
          <>
            <Trash /> Delete
          </>
        )}
      </button>
    </OverlayTrigger>
  );
};

const ActionComp = ({
  props,
  userId,
  setRefresh,
  setShowDownloadModal,
  setScheduleId,
  statusChecker,
  setStatusChecker,
}) => {
  const [loading, setLoading] = useState(false);
  const [action, setAction] = useState(null);
  const masqueradeEmail = useSelector(
    (state) => state.RS_Authentication.masquerade,
  );
  const email = useSelector(
    (state) => state.RS_Authentication.user.details.email,
  );
  const navigate = useNavigate();
  const row = props?.row?.original;
  const scheduleId = row?.schedule_id;

  async function performAction(actionType) {
    try {
      setLoading(true);
      setAction(actionType);

      const url = {
        // download: urls.reportsWidget.downloadReport(scheduleId),
        pause: urls.reportsWidget.pauseReport(scheduleId),
        reRun: urls.reportsWidget.reRunReport(scheduleId),
        resume: urls.reportsWidget.resumeReport(scheduleId),
        delete: urls.reportsWidget.deleteReport,
      };

      const payload = {
        scheduleId: scheduleId,
        user_id: userId,
      };

      if (actionType === "download") {
        // const res = await axios.get(
        //  url[actionType],
        //   oracleConfig,
        // );
        // const a = document.createElement("a");

        // a.href = res?.data?.last_file_url;
        // a.download = res?.data?.last_file_name;
        // document.body.appendChild(a);
        // a.click();
        // a.remove();
        setShowDownloadModal(true);
        setScheduleId(scheduleId);
      } else if (actionType === "delete") {
        const payloadForDelete = {
          sch_id: scheduleId,
          user_id: userId,
          deleted_by:
            masqueradeEmail?.isIt == true
              ? masqueradeEmail?.p_logged_in_email
              : email,
        };
        const res = await axios.post(
          url[actionType],
          payloadForDelete,
          oracleConfig,
        );
        setRefresh();
      } else {
        const res = await axios.post(url[actionType], payload, oracleConfig);
        if(actionType === "reRun"){
          setStatusChecker((statusChecker) => ({
            ...statusChecker,
            scheduleId: scheduleId,
            prevAction: "reRun"
          }))
        }
        setRefresh();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "8px",
      }}
    >
      {row?.can_download === "Y" && (
        <button
          style={{
            border: "none",
            background: "#e9f1ff",
            color: "#295fbe",
            borderRadius: "6px",
            padding: "6px 10px",
            fontSize: "12px",
            fontWeight: 500,
          }}
          disabled={loading}
          onClick={() => performAction("download")}
        >
          {loading && action === "download" ? (
            <div
              style={{ height: "1.2rem", width: "1.2rem" }}
              className="spinner-border"
              role="status"
            />
          ) : (
            <>
              <CloudDownload size={16} /> Download
            </>
          )}
        </button>
      )}

      {row?.can_pause === "Y" && (
        <button
          style={{
            border: "none",
            background: "#ffe7e7",
            color: "#cf2f2f",
            borderRadius: "6px",
            padding: "6px 10px",
            fontSize: "12px",
            fontWeight: 500,
          }}
          disabled={loading}
          onClick={() => performAction("pause")}
        >
          {loading && action === "pause" ? (
            <div
              style={{ height: "1.2rem", width: "1.2rem" }}
              className="spinner-border"
              role="status"
            />
          ) : (
            <>
              <PauseFill /> Pause
            </>
          )}
        </button>
      )}

      {row?.can_rerun === "Y" && (
        <button
          style={{
            border: "none",
            background: "#edf4ff",
            color: "#2f80ed",
            borderRadius: "6px",
            padding: "6px 10px",
            fontSize: "12px",
            fontWeight: 500,
          }}
          disabled={loading}
          onClick={() => performAction("reRun")}
        >
          {loading && action === "reRun" ? (
            <div
              style={{ height: "1.2rem", width: "1.2rem" }}
              className="spinner-border"
              role="status"
            />
          ) : (
            <>
              <ArrowRepeat /> Re-Run
            </>
          )}
        </button>
      )}
      {row?.can_resume === "Y" && (
        <button
          style={{
            border: "none",
            background: "#e8f7ee",
            color: "#198754",
            borderRadius: "6px",
            padding: "6px 10px",
            fontSize: "12px",
            fontWeight: 500,
          }}
          disabled={loading}
          onClick={() => performAction("resume")}
        >
          {loading && action === "resume" ? (
            <div
              style={{ height: "1.2rem", width: "1.2rem" }}
              className="spinner-border"
              role="status"
            />
          ) : (
            <>
              <PlayFill /> Resume
            </>
          )}
        </button>
      )}

      {/* {row?.can_delete === "Y" && ( */}
      <DeleteTrigger
        loading={loading}
        action={action}
        onClick={() => performAction("delete")}
      />
      {/* )} */}

      <button
        style={{
          border: "none",
          background: "#ef8860",
          color: "white",
          borderRadius: "6px",
          padding: "6px 10px",
          fontSize: "12px",
          fontWeight: 500,
        }}
        disabled={loading}
        onClick={() => {
          navigate("/schedule-report", {
            state: {
              prefilled: true,
              reportId: row.schedule_id,
              role: row.role,
            },
          });
        }}
      >
        <PencilSquare /> Edit
      </button>
    </div>
  );
};

export const gridColumns_scheduledReports_RunTime = (
  userId,
  setRefresh,
  setShowDownloadModal,
  setScheduleId,
  statusChecker,
  setStatusChecker,
) => [
  {
    title: "Report Name",
    field: "report_name",
    style: { width: "20%", wordBreak: "break-all" },
    // Cell: (props) => <NavigateButtonForScheduleReportV2 props={props} />,
  },
  {
    title: "Recipients",
    field: "recipients",
    style: { width: "20%", wordBreak: "break-all" },
    Cell: (props) => {
      const row = props?.row?.original;
      // console.log({ row });
      return (
        <div>
          {row?.recipients?.split(",")?.map((el) => (
            <div>{el}</div>
          ))}
        </div>
      );
    },
  },
  {
    title: "Frequency/Next Run",
    field: "frequency",
    Cell: (props) => {
      const row = props?.row?.original;
      return (
        <div>
          {FREQUENCY_MAP[row?.frequency] || row?.frequency}
          <div
            style={{
              color: "#777",
              fontSize: "13px",
            }}
          >
            Next: {moment(row?.next_run_date).format("MM-DD-YYYY")}
          </div>
        </div>
      );
    },
  },

  {
    title: "Live Status",
    field: "live_status",
    Cell: (props) => {
      const row = props?.row?.original;

      const statusConfig = {
        Paused: {
          icon: <HourglassSplit color="#f39c12" />,
          color: "#f39c12",
          bg: "#fff5df",
        },

        Processing: {
          icon: <ArrowRepeat color="#2f80ed" />,
          color: "#2f80ed",
          bg: "#edf4ff",
        },

        "Success - Send Complete": {
          icon: <CheckCircleFill color="#1ca44c" />,
          color: "#1ca44c",
          bg: "#eaf8ef",
        },

        "Failed - Last Attempt": {
          icon: <XCircleFill color="#d93025" />,
          color: "#d93025",
          bg: "#ffeaea",
        },

        "Not Run Yet": {
          icon: <ClockHistory color="#6B7280" />,
          color: "#6B7280",
          bg: "#F3F4F6",
        },
      };

      const currentStatus = statusConfig[row?.live_status];

      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          {currentStatus?.icon}

          <div>
            <strong>{row?.live_status}</strong>

            {/* {(row?.live_status === "Processing" ||
              row?.live_status === "running") && (
              <div
                style={{
                  width: "100%",
                  height: "8px",
                  background: "#ececec",
                  borderRadius: "20px",
                  overflow: "hidden",
                  marginTop: "8px",
                }}
              >
                <div
                  style={{
                    width: `${row?.status?.progress}%`,
                    height: "100%",
                    background: currentStatus.color,
                  }}
                ></div>
              </div>
            )} */}

            <div
              style={{
                color: "#777",
                fontSize: "13px",
              }}
            >
              {row?.last_run_date
                ? `Last Run: ${moment(row?.last_run_date).utc().format("MM-DD-YYYY")}`
                : ""}
            </div>
          </div>
        </div>
      );
    },
  },
  {
    title: "Actions",
    field: "actions",
    style: { width: "30%", wordBreak: "break-all" },
    Cell: (props) => (
      <ActionComp
        props={props}
        userId={userId}
        setRefresh={setRefresh}
        setShowDownloadModal={setShowDownloadModal}
        setScheduleId={setScheduleId}
        statusChecker={statusChecker}
        setStatusChecker={setStatusChecker}
      />
    ),
  },
];

export const gridColumns_scheduledReports_Download = [
  // {
  //   title: "Report Name",
  //   field: "report_name",
  // },
  {
    title: "Last Run Date",
    field: "run_end_date",
    Cell: (props) => <DateConvert props={props} />,
  },

  {
    title: "Download",
    field: "actions",
    Cell: (props) => <DownloadButtonForReports props={props} />,
  },
];

const DownloadButton = ({ props }) => {
const [loading, setLoading] = useState(false);
  const row = props?.row?.original;
     
  const handleDownloadClick = async (name, fileUrl) => {
    setLoading(true);
    const id = toast.loading("Downloading in progress...");
    try {
      const res = await fetch(fileUrl);

      if (!res.ok) {
        throw new Error("Failed to download document");
      }

      const blob = await res.blob();

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      a.remove();

      URL.revokeObjectURL(url);

      toast.update(id, {
        render: "Document Downloaded Successfully",
        type: "success",
        isLoading: false,
        ...commonToast,
      });
    } catch (error) {
      console.error("Error fetching the document:", error);
      toast.update(id, {
        render: "SOME ERROR OCCURED",
        type: "error",
        isLoading: false,
        ...commonToast,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <LoadingButton
        type="button"
        className="btn btn-primary text-white"
        onClick={() => handleDownloadClick(row?.file_name, row?.file_url)}
        title={<><DownloadIcon /> Download</>}
        disabled={row?.can_download === "N" || loading}
        loading={loading}
      />
    </div>
  );
};

export const gridColumns_RecentCompletedReports = [
  {
    title: "Report Name",
    field: "report_name",
    style: { width: "20%", wordBreak: "break-all" },
    // Cell: (props) => <NavigateButtonForScheduleReport props={props} />,
  },
  // {
  //   title: "Description",
  //   field: "description",
  // },
  {
    title: "Completed On",
    field: "completed_on",
    Cell: (props) => <DateConvert props={props} />,
  },

  {
    title: "Execution Time",
    field: "execution_time",
  },
  {
    title: "Actions",
    field: "downloadUrl",
    Cell: (props) => {
      return (
        // <div>
        //   <button
        //     style={{
        //       border: "none",
        //       background: "#e9f1ff",
        //       color: "#295fbe",
        //       borderRadius: "6px",
        //       padding: "6px 10px",
        //       fontSize: "12px",
        //       fontWeight: 500,
        //       cursor: row?.can_download === "Y" ? 'pointer' : 'not-allowed'
        //     }}
        //   >
        //     <DownloadIcon /> Download
        //   </button>
        // </div>
        <DownloadButton props={props} />
      );
    },
  },
];

export const gridColumns_payoff_authorization = (isExternalBorrower = false) => [
  {
    field: "account_number",
    title: "Loan Number",
    Cell: (props) => (
      <PayOffRequestCell props={props} isExternalBorrower={isExternalBorrower} />
    ),
  },
  {
    field: "borrower_fullname",
    title: "Full Name",
  },
  {
    field: "property_address",
    title: "Property Address",
  },

  {
    field: "payoff_good_through_date",
    title: "Payoff Good Through Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "demand_expiration_date",
    title: "Demand Expiration Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "requestor_email",
    title: "Requestor Email",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "requestor_name",
    title: "Requestor Name",
  },

  // {
  //   field: "CalculatedPayoff",
  //   title: "Calculated Payoff",
  // },
  {
    field: "status",
    title: "Status",
  },
  {
    field: "created",
    title: "Creation Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "created_by",
    title: "Created By",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "updated",
    title: "Last Update Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "updated_by",
    title: "Last Updated By",
    style: { width: "10%", wordBreak: "break-all" },
  },
];

export const gridColumns_payoff_authorization_borrower = (isThirdParty = false) => [
  {
    field: "account_number",
    title: "Loan Number",
    Cell: (props) => (
      <PayOffRequestCellV2 props={props} isthirdParty={isThirdParty} />
    ),
  },
  {
    field: "borrower_fullname",
    title: "Full Name",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "property_address",
    title: "Property Address",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },

  {
    field: "payoff_good_through_date",
    title: "Payoff Good Through Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "demand_expiration_date",
    title: "Demand Expiration Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "requestor_email",
    title: "Requestor Email",
    style: { width: "10%", wordBreak: "break-all" },
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "requestor_name",
    title: "Requestor Name",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },

  // {
  //   field: "CalculatedPayoff",
  //   title: "Calculated Payoff",
  // },
  {
    field: "status",
    title: "Status",
  },
  {
    field: "created",
    title: "Creation Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "created_by",
    title: "Created By",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "updated",
    title: "Last Update Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "updated_by",
    title: "Last Updated By",
    style: { width: "10%", wordBreak: "break-all" },
  },
];

export const gridColumns_demandPayoff_Borrower = [
  {
    field: "loan_number",
    title: "Loan Number",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "fullname",
    title: "Full Name",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },
  {
    field: "property_address",
    title: "Property Address",
    Cell: ({ value }) => <BlurWrapperWithSpan>{value}</BlurWrapperWithSpan>,
  },

  {
    field: "payoff_good_through_date",
    title: "Payoff Good Through Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "demand_expiration_date",
    title: "Demand Expiration Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  // {
  //   field: "payoff_amount",
  //   title: "Payoff Amount",
  //   Cell: (props) => <DollarConvert props={props} />,
  // },
  {
    field: "principal_balance",
    title: "Principal Balance",
    Cell: (props) => <DollarConvert props={props} />,
  },

  // {
  //   field: "CalculatedPayoff",
  //   title: "Calculated Payoff",
  // },
  {
    field: "status",
    title: "Status",
  },
  {
    field: "creation_date",
    title: "Creation Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "created_by",
    title: "Created By",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "last_update_date",
    title: "Last Update Date",
    Cell: (props) => <DateConvert props={props} />,
  },
  {
    field: "last_updated_by",
    title: "Last Updated By",
  },
];